/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SidebarChangeTypeItem.vue?vue&type=template&id=541c4244"
import script from "./SidebarChangeTypeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarChangeTypeItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports